import { render } from "./Headers.vue?vue&type=template&id=ca4189c8&scoped=true&ts=true"
import script from "./Headers.vue?vue&type=script&lang=ts"
export * from "./Headers.vue?vue&type=script&lang=ts"

import "./Headers.vue?vue&type=style&index=0&id=ca4189c8&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4189c8"]])

export default __exports__